let Stage;
(function (Stage) {
  Stage["Complete"] = "complete";
  Stage["Usable"] = "usable";
})(Stage || (Stage = {}));

export { Stage };
